import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { toast_error } from '@/libs/toast-wrappers';
import { DeleteNpiProviderParams, deleteNpiProvider } from '@/api/npi-preferred';
import { toError } from '@/utils/errors';

export const useDeletePreferredProvider = () => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const request = async (params: DeleteNpiProviderParams) => {
    setLoading(true);

    try {
      await deleteNpiProvider(params);
      setLoading(false);
    } catch (error) {
      toast_error(t('npi-remove-preferred-error'));
      setLoading(false);
      return Promise.reject(toError(error));
    }

    setLoading(false);
  };

  return { loading, request };
};
